export default {
  // ai发送问题
  getUserMemberInfoCountByPhone: '/view/member/getUserMemberInfoCountByPhone',
  // 获取历史聊天记录
  smsMsg: '/view/member/smsMsg',
  // 企业子账号登录
  loginMember: '/view/member/loginMember',
}
